import { EventEmitter, Injectable } from '@angular/core';

import { NotificationOptions } from '../models/notification-options';


@Injectable({
    providedIn: 'root'
})
export class FailedJobsService {

    failedJobsChanged: EventEmitter<void> = new EventEmitter();
    notificationOptionsLoaded: EventEmitter<NotificationOptions> = new EventEmitter();

    notifyFailedJobsChange(): void {
        this.failedJobsChanged.emit();
    }

    notifyNotificationOptionsLoaded(notificationOptions: NotificationOptions): void {
        this.notificationOptionsLoaded.emit(notificationOptions);
    }
}
